module.exports = require('events').EventEmitter;



//////////////////
// WEBPACK FOOTER
// /var/www/_deploy/front-company-testing/2018-09-30-21-57-10/node_modules/readable-stream/lib/internal/streams/stream-browser.js
// module id = ../../../../readable-stream/lib/internal/streams/stream-browser.js
// module chunks = vendor